import {Component} from 'react';

import ClassImporter from './library/ClassImporter.js';
import Factory from './library/Factory.js';

class App extends Component {

  open(options) {

    window.dataLayer = window.dataLayer || [];

    this.factory = new Factory(ClassImporter, this.props.properties, options.locale, options.redirect_url, options.tracking_context, window.dataLayer, this);
    this.factory.initialiseFactory()
      .then(() => {
        this.factory.getController().showEmailCapturePage();
      });

    this.setState(getOpenState(options, this.factory.getViewBuilder()));

  }

  // Render

  render() {
    (this.state !== null && this.state.show) ? setBodyClassName() : unSetBodyClassName();

    return (
      this.state !== null
      && this.state.show
    ) ? this.factory.getViewBuilder().getWidget() : null;

  }

}

let getOpenState = function (options, viewBuilder) {

  return {
    actionInProgress: false,
    show: true,
    emailAddress: undefined,
    password: undefined,
    rememberMe: false,
    formError: undefined,
    emailAddressErrorMessage: undefined,
    passwordErrorMessage: undefined,
    view: viewBuilder.getLoadingAppView,
    onSuccess: options.onSuccess,
    onFailure: options.onFailure
  };

};

let setBodyClassName = function () {
  document.body.classList.add('modal-open');

   if (isIOSversionInARange()) {
       document.body.classList.add('iOS-small-issue');
   }

};

let unSetBodyClassName = function () {
  document.body.classList.remove('modal-open');
  document.body.classList.remove('iOS-small-issue');
};

// for 11_0|OS 11_1|OS 11_2/OS
let isIOSversionInARange = function () {
  let isIOSversionInARange = false;
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
      let v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      if (parseInt(v[1], 10) >= 11 && parseInt(v[2], 10) < 3) {
          isIOSversionInARange = true;
      }
  }

  return isIOSversionInARange;
};


export default App;



// WEBPACK FOOTER //
// ./src/App.js